import { useEffect, useRef } from 'react'
import { renderToStaticMarkup } from 'react-dom/server'
import { withLocalize } from 'react-localize-redux'
import cn from 'translations/cn.json'
import en from 'translations/en.json'
import de from 'translations/de.json'
import es from 'translations/es.json'
import it from 'translations/it.json'
import pl from 'translations/pl.json'
import jp from 'translations/jp.json'
import { getLocale, setLocale } from 'utils/localstorage'
import languages from 'constants/languages'

const LocalizeInitializer = ({
  children,
  initialize,
  addTranslationForLanguage,
  setActiveLanguage,
}) => {
  const initialized = useRef(false)

  useEffect(() => {
    if (initialized.current) return
    initialized.current = true
    const translations = {
      cn,
      en,
      de,
      es,
      it,
      pl,
      jp,
    }

    initialize({
      languages,
      options: { renderToStaticMarkup },
    })

    Object.entries(translations).forEach(([lang, translation]) => {
      addTranslationForLanguage(translation, lang)
    })

    const isValidLocale = languages.some((l) => l.code === getLocale())
    const finalLocale = isValidLocale ? getLocale() : 'en'

    if (!isValidLocale) {
      setLocale('en')
    }

    setActiveLanguage(finalLocale)
  }, [initialize, addTranslationForLanguage, setActiveLanguage])

  return children
}

export default withLocalize(LocalizeInitializer)
